<style scoped lang="sass">
.topic
  margin-bottom: 1rem
  .question
    margin-bottom: 0.3rem
</style>
<template>
  <div class="page">
    <div class="padded">
      <div class="topic" v-for="topic in topics">
        <a href="#" @click.prevent="toggleAnswer(topic)" class="question">{{topic.question}}</a>
        <div class="answer" v-html="topic.answer" v-if="openAnswers[topic.question]"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Faq',
  data() {
    return {
      topics: [
        {
          question: 'What does MDF mean?',
          answer: 'On the PGA Tour, the result given to those players who made the cut after the first two days, but were subject to a second cut after the third day, due to the size of the first cut. The cut line on the PGA Tour is generally top 70 plus ties'
        },
        {
          question: 'I forgot to make picks, what happens?',
          answer: 'As long as you accepted the invitation to play but neglected to make your picks, random ones will be chosen for you. Good luck with that!'
        },
        {
          question: 'What happens if I accept a pool invitation but don\'t make my picks before the tournament starts?',
          answer: 'Your picks will be made automatically at the start of the tournament and randomly. Don\'t worry you\'re not out of it yet!'
        },
        {
          question: 'How are the player brackets determined?',
          answer: 'The field for upcoming tournaments is set during the week before a tournament begins. This field of players is sorted based on their rank in the world golf rankings. Then the field is divided up in to brackets based on percentages which can be adjusted by the pool creator.'
        },
        {
          question: 'I don\'t understand how the scoring works, can you explain?',
          answer: 'Read the "Details" tab under the pool in question very carefully. Take special note that players who make the cut but do not finish for any reason other than MDF (ie: withdrew WD, no card NC, disqualified DQ, did not finish DNF, did not show DNS) will not count as finishing players.'
        },
        {
          question: 'What happens if select a player and they withdraw from the tournament before it starts?',
          answer: 'All picks are the responsibility of the contestant (that\'s you). The official tournament list is set on Sunday usually, and when it\'s done, PinHigh doesn\'t change it (unless in extreme situations). It\'s up to you as the contestant to change your pick if one of your players withdraws before tournament start or that pick will be dead in the water.'
        },
        {
          question: 'Why does one of my picks not show up in the tournament field?',
          answer: 'The tournament field is set in the week before each tour event. Shortly after that happens is when the field is synced to pinhigh.co. If a player then withdraws from the tournament after the field is set, it is up to the participant to adjust their pick before the tournament starts. If the change isn\'t made on time, the pick will be worth 0 points.'
        },
        {
          question: 'How are ties in points broken?',
          answer: 'Ties in points are broken by comparing the finishing position of the best picks from each contestant. If there is still a tie, we move on to the next best finishing position and so on.'
        },
        {
          question: 'How do I delete a pool?',
          answer: 'You can delete a pool as the owner of it if it has not started yet and you have removed all participants from it. Look for the edit "three dots" on the pool page to access the delete button.'
        },
        {
          question: 'When will the tournament field be set?',
          answer: 'Usually the Saturday before the tournament starts, but it can vary by a day or 2.'
        },
        {
          question: 'Why doesn\'t the player who shot a low round then withdrew counting for a low round?',
          answer: 'We have elected to set scoring so that players who withdraw, no show, are disqualified, or do not turn in a card to not count for any points at all.'
        },
      ],
      openAnswers: {}
    };
  },
  created() {
    this.$store.dispatch('configNavigation', {leftEnabled: true, leftRoute: {name: 'dashboard'}, leftImg: 'icon-back.svg'});
  },
  methods: {
    toggleAnswer({question}) {
      this.$set(this.openAnswers, question, !!!this.openAnswers[question]);
    }
  }
};
</script>
